import { Select } from '@mantine/core';
import { useList } from '../api/hooks/useCrud.ts';
import type { Country } from '../api/schemas/entities.ts';

export function CountrySelect({
  value,
  onChange,
  label,
}: {
  value: number | null | undefined;
  onChange: (id: number | null) => void;
  label?: string;
}) {
  const { data } = useList<Country>('countries');
  const options = (data ?? [])
    .filter(c => c.id != null)
    .map(c => ({ value: String(c.id), label: c.name ?? `#${c.id}` }));
  return (
    <Select
      label={label ?? 'Country'}
      data={options}
      value={value == null ? null : String(value)}
      onChange={s => onChange(s == null ? null : Number(s))}
      searchable
      clearable
    />
  );
}
